module.exports = __webpack_public_path__ + "img/zahar.2ab3c142.jpg";